<div>
    <img class="logo__image" src="https://content.gruposancristobal.com/common/images/grupo-san-cristobal/logo-gsc-negativo-verde-151x52.svg" alt="GSC-logo">
    <span class="copyright">
    © 2023 Grupo San Cristóbal - Todos los derechos reservados.
</span>
</div>

